export default __webpack_public_path__ + "static/media/logo.d408a20b.svg";